import { useQuery } from "@tanstack/react-query";
import tokenService from "../services/tokenService";

interface TokenResponse {
    balance: number;
    totalPurchased: number;
    totalUsed: number;
    totalRefunded: number;
    isActive: boolean;
}

const useTokenBalance = () => {
    return useQuery({
        queryKey: ["tokenBalance"],
        queryFn: () => tokenService.getTokenBalance(),
        refetchInterval: 30000, // Refetch every 30 seconds
        staleTime: 10000, // Consider data stale after 10 seconds
    });
};

export default useTokenBalance;
